import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import PortableWifiOffIcon from "@mui/icons-material/PortableWifiOff";
import SignalWifi4BarIcon from "@mui/icons-material/SignalWifi4Bar";
import SignalWifiStatusbarConnectedNoInternet4Icon from "@mui/icons-material/SignalWifiStatusbarConnectedNoInternet4";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { TachographConnectivity, TachographStatus } from "../models/Tachograph";
import { getStatusColor } from "../utilities/tachographStatus";

type Props = {
  value: TachographStatus | TachographConnectivity;
  label: string;
};

function getIcon(value: TachographStatus | TachographConnectivity, color: string) {
  switch (value) {
    case "ok":
      return <CheckCircleIcon fontSize="small" sx={{ color }} />;
    case "warning":
      return <WarningAmberIcon fontSize="small" sx={{ color }} />;
    case "overdue":
      return <ErrorIcon fontSize="small" sx={{ color }} />;
    case "online":
      return <SignalWifi4BarIcon fontSize="small" sx={{ color }} />;
    case "degraded":
      return <SignalWifiStatusbarConnectedNoInternet4Icon fontSize="small" sx={{ color }} />;
    default:
      return <PortableWifiOffIcon fontSize="small" sx={{ color }} />;
  }
}

/** The colored symbol a status column shows, with the status spelled out on hover. */
export function TachographStatusIcon({ value, label }: Props) {
  return (
    <Tooltip title={label}>
      <Box
        component="span"
        sx={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}
      >
        {getIcon(value, getStatusColor(value))}
      </Box>
    </Tooltip>
  );
}
